module.exports = __webpack_public_path__ + "static/media/black-tshirt-woman-front-min.8e6f1379.png";